module.exports = __webpack_public_path__ + "img/refresh.283c96fc.svg";